import React from 'react';
import { Badge, Layout } from '@axiom/ui';
import type { Candidate } from '@axiom/validation';
import { CandidatesConst } from '@axiom/const';

export const TalentCarouselBadge = ({
  candidate,
  isSavedCarousel,
  name,
}: {
  candidate: Pick<Candidate, 'availabilityStatus'>;
  isSavedCarousel?: boolean;
  name?: string;
}) => {
  const availabilityStatus =
    CandidatesConst.AvailabilityStatuses[
      candidate.availabilityStatus as keyof typeof CandidatesConst.AvailabilityStatuses
    ];

  switch (candidate.availabilityStatus) {
    case CandidatesConst.AvailabilityStatusKeys.AvailableNow: {
      return (
        <Layout inline>
          <Badge name={name || 'AVAILABLE_NOW_BADGE'} background="light orange">
            {availabilityStatus}
          </Badge>
        </Layout>
      );
    }

    case CandidatesConst.AvailabilityStatusKeys.AvailableSoon: {
      return (
        <Layout inline>
          <Badge
            name={name || 'AVAILABLE_SOON_BADGE'}
            background={isSavedCarousel ? 'gray' : 'light blue'}
          >
            {availabilityStatus}
          </Badge>
        </Layout>
      );
    }

    default: {
      return null;
    }
  }
};
